import { render, staticRenderFns } from "./TooltipVariant.vue?vue&type=template&id=13750854&"
import script from "./TooltipVariant.vue?vue&type=script&lang=js&"
export * from "./TooltipVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports